import React from "react";
import {Stack} from "@mui/material";
import {Bolt} from "@mui/icons-material";
import PageTitle from "./layout/PageTitle.js";
import ButtonCreate from "./layout/ButtonCreate.js";
import Loader from "./layout/loading/loader.js";
import Constants from "../../utils/constants.js";
import {toastHelper} from "../../utils/toast-helper.js";
import ActeTable from "./referentiel/actes/ActeTable.js";
import {useGetActesQuery, useDeleteActeMutation} from "../../modules/actes/actes.api.js";

export default function ActesPage() {
    const {data: actes = [], isLoading} = useGetActesQuery();
    const [deleteActe] = useDeleteActeMutation();

    const handleDelete = async (a) => {
        try {
            await deleteActe(a.id).unwrap();
            toastHelper.displaySuccess("Acte supprimé.");
        } catch (e) {
            // Remonte le motif serveur (ex. 409 : acte encore lié à un formulaire),
            // sinon message générique.
            const serverMsg = e?.data?.["hydra:description"] || e?.data?.detail || e?.data?.message;
            toastHelper.handleError(e, serverMsg || "Oops, une erreur est survenue.");
        }
    };

    return (
        <>
            <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
                <PageTitle title={"Actes"} icon={<Bolt/>}/>
                <ButtonCreate route={Constants.APP_ROUTE_ADMIN_ACTES_NEW} label={"Ajouter un acte"}/>
            </Stack>

            {isLoading ? <Loader/> : <ActeTable actes={actes} onDelete={handleDelete}/>}
        </>
    );
}
